//NOTE: this should only ever be used client side!
const getQueryStringVariable = (key) => {
  if (window.location.search) {
    const searchQuery = window.location.search.substring(1);
    const vars = searchQuery.split("&");
    const qsVariable = vars.find((v) => v.indexOf(key) >= 0);
    if (qsVariable) {
      const val = parseInt(qsVariable.split("=")[1]);
      return val;
    }
  }
  return null;
};
export default getQueryStringVariable;
